import { render, staticRenderFns } from "./en-GB.vue?vue&type=template&id=7e975cee&"
import script from "./en-GB.vue?vue&type=script&lang=js&"
export * from "./en-GB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e975cee')) {
      api.createRecord('7e975cee', component.options)
    } else {
      api.reload('7e975cee', component.options)
    }
    module.hot.accept("./en-GB.vue?vue&type=template&id=7e975cee&", function () {
      api.rerender('7e975cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/en-GB.vue"
export default component.exports